package component.navigation

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import component.image.AsyncImageView
import theme.ThemeColor

@Composable
fun BrandedNavBar(
    title: String = "Title",
    onBackPress: (() -> Unit)? = null,
    onClickAdd: (() -> Unit)? = null
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(54.dp)
    ) {
        Row(
            modifier = Modifier.fillMaxHeight().fillMaxWidth()
                .background(ThemeColor.shared().PrimaryColor),
            horizontalArrangement = Arrangement.Start,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Box(modifier = Modifier.width(40.dp).height(40.dp).padding(start = 8.dp)) {
                AsyncImageView("https://firebasestorage.googleapis.com/v0/b/friendly-221119.appspot.com/o/bharat_bandhu%2FIcon-App-76x76%402x.png?alt=media&token=74919063-7378-49f7-9de3-981958264bbc")
            }
            Text(
                modifier = Modifier
                    .width(300.dp).height(50.dp).padding(top = 10.dp, start = 8.dp),
                text = title,
                color = ThemeColor.shared().White,
                fontSize = 18.sp,
                fontWeight = FontWeight.Bold,
                textAlign = TextAlign.Left
            )
        }
    }
}